import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useWhatsNewCountQuery } from "../graphql/cms/hooks/useWhatsNewCountQuery";
import { badgesActions } from "../store/badges";
import { State } from "../store/types";
import { hasLocalStorage } from "../utils/features";
import UnreadIndicator from "./UnreadIndicator";

export const WhatsNewBadge = () => {
  const dispatch = useDispatch();
  const lastCheckedDate = useSelector(
    (state: State) => state.badges.whatsNew.lastChecked
  );

  useEffect(() => {
    if (!hasLocalStorage()) {
      return;
    }
    const lastChecked = localStorage.getItem("wn");
    if (!lastChecked) {
      // Resettings the badge records todays date for future checks
      dispatch(badgesActions.resetWhatsNewBadge());
    } else {
      // We have a last checked date, let's find how many posts since then
      const date = new Date(lastChecked);
      dispatch(
        badgesActions.setWhatsNewDate({
          date
        })
      );
    }
  }, [dispatch]);

  const flags = useSelector(
    (state: State) =>
      state.features.flags &&
      state.features.flags.filter(f => f.isEnabled).map(f => f.name)
  );

  const { data } = useWhatsNewCountQuery({
    skip: !lastCheckedDate,
    variables: {
      lastUpdate: lastCheckedDate,
      flags: flags ? flags : []
    }
  });

  if (
    lastCheckedDate &&
    data &&
    data._allProductUpdatesMeta &&
    data._allProductUpdatesMeta.count > 0
  ) {
    return <UnreadIndicator />;
  }
  return null;
};
